import { Spacing } from "../../../../../types/Spacing";

type FormHrProps = {
  className?: string;
  margin?: Spacing;
};

function FormHr({ className, margin = "xl" }: FormHrProps) {
  const hrStyle = {
    height: 4,
    backgroundColor: "#F7F9FA",
    border: "none",
  };
  return <hr style={hrStyle} className={`${className} ml-neg-${margin} mr-neg-${margin}`} />;
}

export default FormHr;

FormHr.defaultProps = {
  className: "",
  margin: "xl",
};
